import React from "react";
import Sidebar from "../components/Sidebar";
import ProblemList from "../Pages/ProblemList";

function Secpage() {
  return (
    <>
    <div className="flex h-screen">
      <Sidebar />
      <div className="flex-1 p-6 bg-[#222] overflow-auto">
        <ProblemList/>
      </div>
    </div>
    </>
  );
}

export default Secpage;
